import {
  type OnboardingClientEvent,
  type OnboardingPath
} from '@shared/all/domains/onboarding';

import { getInstallationId } from '../../utils/installationId';
import { client } from '../../utils/trpc';

// Fire-and-forget funnel event; onboarding must never block on tracking. Keyed
// to the device (installationId) so the pre-auth funnel is tracked anonymously.
export const trackOnboarding = (type: OnboardingClientEvent, meta?: string) => {
  void client.onboarding.trackEvent.mutate({
    type,
    meta,
    installationId: getInstallationId()
  });
};

// Fire ACTIVATED only for the user's primary path (keeps attribution on it).
export const trackActivation = (
  onboardingPath: string | null,
  path: OnboardingPath
) => {
  if (onboardingPath === path) trackOnboarding('ACTIVATED', path);
};
